import React, { useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import secureLocalStorage from "react-secure-storage";

// 어드민 콘솔 좌측 사이드바 메뉴. superOnly=최고관리자(ADMIN)만, 나머지는 일반관리자(SUB_ADMIN)도 노출.
// onlyUserIds=그 계정(uxn_user_id)에게만 노출 (서버도 같은 명단으로 막음).
const MENU = [
  { label: "전체 유저", path: "/admin/users" },
  { label: "기기 목록", path: "/admin/devices", superOnly: true },
  { label: "차단 목록", path: "/admin/blocked", superOnly: true },
  { label: "탈퇴 목록", path: "/admin/withdrawn", superOnly: true },
  { label: "FCM 발송 기록", path: "/admin/fcm-logs", superOnly: true, onlyUserIds: [4952, 5002] },   // 장재용·오원준
  { label: "확증임상 엑셀 변환", path: "/admin/confirmatory-excel", superOnly: true },
  // 혈당 데이터 체크(/admin/glucose-check)는 메뉴에 안 둠 — 감도표 오등록 검사 때 Claude 가 주소로 직접 여는 화면(10/19). 권한은 화면 안에서 5002만.
];

const SIDEBAR_W = 220;
const HEADER_H = 74;

const AdminLayout = ({ children }) => {
  const history = useHistory();
  const { i18n } = useTranslation();
  const current = history.location.pathname;

  // 언어 전환은 추후 작업 — admin 콘솔은 한국어 고정(영어로 물려있어도 ko로)
  useEffect(() => {
    if (i18n.language !== "ko") i18n.changeLanguage("ko");
  }, [i18n]);

  return (
    // alignItems 기본(stretch) → 사이드바가 콘텐츠 영역 전체 높이를 채움(헤더 아래 ~ 푸터 위).
    // minHeight로 콘텐츠가 짧아도 최소 한 화면은 채워서 사이드바가 짧아 보이지 않게.
    <div style={{ display: "flex", minHeight: `calc(100vh - ${HEADER_H}px)` }}>
      {/* 왼쪽 사이드바 */}
      <aside
        style={{
          width: SIDEBAR_W,
          flexShrink: 0,
          backgroundColor: "#787397",
          color: "#fff",
          paddingTop: "24px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            padding: "0 20px 20px",
            fontWeight: "bold",
            fontSize: "18px",
            letterSpacing: "2px",
          }}
        >
          ADMIN
        </div>
        <nav>
          {MENU.filter((m) => (!m.superOnly || Number(secureLocalStorage.getItem("role")) === 1001)
              && (!m.onlyUserIds || m.onlyUserIds.includes(Number(secureLocalStorage.getItem("authUser"))))).map((m) => {
            const active = current === m.path;
            return (
              <div
                key={m.path}
                onClick={() => history.push(m.path)}
                style={{
                  padding: "12px 20px",
                  cursor: "pointer",
                  fontWeight: active ? "bold" : "normal",
                  backgroundColor: active ? "#665f85" : "transparent",
                  borderLeft: active ? "4px solid #E4DBEF" : "4px solid transparent",
                }}
              >
                {m.label}
              </div>
            );
          })}
        </nav>
      </aside>

      {/* 오른쪽 컨텐츠 (minWidth:0 = 좁아질 때 테이블이 넘치지 않고 내부 스크롤) */}
      <main
        style={{
          flex: 1,
          minWidth: 0,
          padding: "30px 40px",
          boxSizing: "border-box",
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default withRouter(AdminLayout);
